// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"a0234e84","53":"2c2e81d2","167":"9832fc82","266":"4e312c45","507":"b4834486","639":"15483c56","650":"6b992131","736":"23ba75a0"}[chunkId] + ".chunk.js";
};